import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import { Categories } from 'api'
import Product from "components/partials/product";
import { ShowIf } from 'components/utils';
import {API_URL} from 'constants/config';
import {openPopupProductDetail} from 'actions';
import {connect} from 'react-redux';
import {NoContent} from 'components/no-content';

class CategoryInFair extends Component {
  constructor() {
    super();
    this.state = {
      typeView: 'NEWEST',
      countProduct: 0,
      data: [],
      featuredProduct: {},
      featuredBanner: null
    }
  }

  onChange(value) {
    this.setState({data: [], typeView: value}, ()=> {this.getData(value)})
  }

  componentDidMount() {
    Categories.actions.countFixProduct.request({id: this.props.id}).then(res => {
      if (res.data > 0) {
        this.setState({countProduct: res.data})
        this.getData('NEWEST');
      }
    })
  }

  getData(type) {
    let params = {
      filter: {
        limit: 10,
        where: {
          status: 1
        },
      }
    }
    if (type === 'NEWEST') {
      params.filter.order = 'createdAt DESC'
    } else {
      params.filter.where.isFeatured = true
    }
    Categories.actions.listProducts.request({id: this.props.id}, params).then(res => {
      if (res.data) {
        this.setState({data: res.data})
      }
    })
  }

  showFeatureProduct() {
    this.props.dispatch(openPopupProductDetail(this.state.featuredProduct.id))
  }

  render() {
    let { data, typeView, countProduct } = this.state
    let { name, id } = this.props
    return (
      <div>
        {
          countProduct > 0 ? (
            <div className='category-of-fair'>
              <div className='header-category'>
                <Link to={`/list-products/${id}`} className='content-header-category'>{name}</Link>
                <div className='shape1-header-category'></div>
                <div className='shape2-header-category'></div>
                <div className='list-tab'>
                  <button className={`btn-tab ${typeView === 'NEWEST' ? 'active' : ''}`} onClick={this.onChange.bind(this, 'NEWEST')}>Mặt hàng mới nhất</button>
                  {/* hidden - 14/03/2019 */}
                  {/* <button className={`btn-tab ${typeView !== 'NEWEST' ? 'active' : ''}`} onClick={this.onChange.bind(this, 'HIGHLIGHT')}>Mặt hàng nổi bật</button> */}
                </div>
              </div>
              <ShowIf condition={this.props.featuredBanner}>
                <a href={this.props.accompanyingInfo && this.props.accompanyingInfo.link || '#'} target='_blank' className='feature-product' style={{backgroundImage: `url(${API_URL}/containers/categories/download/${this.props.featuredBanner})`}}>
                </a>
              </ShowIf>
              <div className='list-product-by-category'>
                {
                  data.map((item, i) => {
                    if (i < 10) {
                      return (
                        <div key={i} className='wrap-product'>
                          <Product
                            enableSendRequest={false}
                            enableAddProduct={true}
                            {...item}/>
                        </div>
                      );
                    }
                  })
                }
                <ShowIf condition={data.length === 0}>
                  <NoContent content='Chưa có sản phẩm nào' height={300}/>
                </ShowIf>
              </div>
              <ShowIf condition={countProduct > 10}>
                <div className='wrap-view-more'>
                  <Link to={`/list-products/${id}`} className='view-more'>Xem thêm sản phẩm</Link>
                </div>
              </ShowIf>
            </div>
          ) : null
        }
      </div>
    );
  }
}


export default connect()(CategoryInFair)


// WEBPACK FOOTER //
// ./components/home/sub-view/CategoryInFair.jsx